
import React, { Fragment } from 'react'

import { useProgrammation } from '@/Hooks/UseProgrammation'

import ContentBlock from '../../components/ContentBlock'

import ConstraintCreator from './ConstraintCreator'
import { ListGroup } from 'react-bootstrap'
import ConstraintItem from './ConstraintItem'

import './Constraints.scss'

const WorksConstraints = () => {

  const { itemOpened } = useProgrammation()

  return (
    <ContentBlock
      title="Constraints"
      collapsable
    >
      {itemOpened.subTasks.map((subTask: any) => (
        <Fragment key={subTask._id}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className='work-name'>
              {subTask.name}
            </div>
            <div>
              <ConstraintCreator subTask={subTask} />
            </div>
          </div>
          <ListGroup>
            {subTask.restrictions.map((r: any, i: number) => (
              <ConstraintItem
                key={i}
                constraint={r}
                subTask={subTask}
              />
            ))}
          </ListGroup>
          <div style={{ margin: 4, backgroundColor: '#efefef', height: 1 }}></div>
        </Fragment>
      ))}
    </ContentBlock>
  )
}

export default WorksConstraints
